import useCheckPC from "@repo/hooks/utils/useCheckPC";
import type { IMenuQuery } from "@repo/shopify/src/queries/others-gql";
import _uniqueId from "lodash/uniqueId";
import React, { useState } from "react";

import NavMenuItem from "@molecules/NavMenu/NavMenuItem";
import NavMenu from "@molecules/NavMenu/index";

const STORE_URL = "https://tuneglobal.myshopify.com/";

export default function StoreNavMenuItems({ storeNav }: { storeNav: IMenuQuery | undefined }) {
  const { isPC } = useCheckPC();

  /** 모바일에서 각 메뉴를 탭 형태로 열어주는 state **/
  const [currentStoreMenuIdx, setCurrentStoreMenuIdx] = useState(-1);

  return (
    <>
      {storeNav?.menu.items.map((storeNavMenu, index) => (
        /**
         * 받아온 Nav list mapping =>
         * PC, 모바일 모두 featured 만 형태가 다르므로 featured 메뉴만 따로 구별해줌
         * */
        <React.Fragment key={`${storeNavMenu.title}-${_uniqueId()}`}>
          {storeNavMenu.title === "featured" ? (
            <>
              <NavMenu title={storeNavMenu.title}>
                {storeNavMenu.items.map((item) => (
                  <NavMenuItem
                    goToUrl={item.url ? item.url.replace(STORE_URL, "") : ""}
                    key={`${item.title}-${_uniqueId()}`}
                    name={item.title}
                  />
                ))}
              </NavMenu>
              {isPC ? (
                <span className="relative">
                  <span className="absolute inset-x-1/2 block h-full w-px bg-secondary" />
                </span>
              ) : (
                <span className="my-4 block h-px w-full bg-secondary" />
              )}
            </>
          ) : (
            /**
             * 나머지 메뉴 리스트 매핑
             * PC와 모바일로 구분
             */
            <>
              {isPC ? (
                <NavMenu title={storeNavMenu.title}>
                  {storeNavMenu.items.map((item) => (
                    <NavMenuItem
                      goToUrl={item.url ? item.url.replace(STORE_URL, "") : ""}
                      key={`${item.title}-${_uniqueId()}`}
                      name={item.title}
                    />
                  ))}
                </NavMenu>
              ) : (
                <NavMenu
                  currentStoreMenuIdx={currentStoreMenuIdx}
                  index={index}
                  isMobileNavMenu
                  key={`${storeNavMenu.title}-${_uniqueId()}`}
                  selectStoreMenuHandler={(menuIndex) => {
                    setCurrentStoreMenuIdx(menuIndex);
                  }}
                  title={storeNavMenu.title}
                >
                  {storeNavMenu.items.map((item) => (
                    <NavMenuItem
                      goToUrl={item.url ? item.url.replace(STORE_URL, "") : ""}
                      key={`${item.title}-${_uniqueId()}`}
                      name={item.title}
                    />
                  ))}
                </NavMenu>
              )}
            </>
          )}
        </React.Fragment>
      ))}
    </>
  );
}
